import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import UserData from './UserData';
import Directions from './Directions';
import Input from 'components/bronson/Input';

import { vehicleTypes } from 'components/rentingRedRac/types';

const SubmitPage = ({ t, values, setFieldValue, vehicle, renderError }) => {
    const customDirectionKeys = useMemo(
        () => ({
            streetType: 'fiscalStreetType',
            street: 'fiscalStreet',
            streetNumber: 'fiscalStreetNumber',
            streetFloor: 'fiscalStreetFloor',
            postalCode: 'fiscalPostalCode',
            city: 'fiscalCity',
            poblation: 'fiscalPoblation',
        }),
        []
    );
    return (
        <>
            <Header t={t} values={values} vehicle={vehicle} />
            <hr />
            <UserData
                t={t}
                values={values}
                renderError={renderError}
                setFieldValue={setFieldValue}
                disabled={values.autocompleted}
            />
            <hr />
            <h5 className="u-mb-large">{`${t.getTraduction(
                'AddressLabel'
            )} ${t.getTraduction('Physical')}`}</h5>
            <Directions
                t={t}
                values={values}
                renderError={renderError}
                setFieldValue={setFieldValue}
                disabled={values.autocompleted}
            />
            <hr />
            <h5 className="u-mb-large">{`${t.getTraduction(
                'AddressLabel'
            )} ${t.getTraduction('Fiscal')}`}</h5>
            <Input
                options={{
                    id: 'copyDirection',
                    type: 'checkbox',
                    name: 'copyDirection',
                    text: {
                        text: t.getTraduction('CopyDirection'),
                        className: 'u-mb-large',
                    },
                    disabled: values.autocompleted,
                }}
                boolValue={values.copyDirection}
                onChange={value => {
                    setFieldValue('copyDirection', value);
                    if (value)
                        Object.values(customDirectionKeys).forEach(key =>
                            setFieldValue(key, '')
                        );
                }}
            />
            {!values.copyDirection && (
                <Directions
                    t={t}
                    values={values}
                    renderError={renderError}
                    setFieldValue={setFieldValue}
                    customKeys={customDirectionKeys}
                    disabled={values.autocompleted}
                />
            )}
        </>
    );
};

SubmitPage.propTypes = {
    t: PropTypes.shape({
        getTraduction: PropTypes.func.isRequired,
    }),
    values: PropTypes.object,
    vehicle: vehicleTypes,
    setFieldValue: PropTypes.func.isRequired,
    renderError: PropTypes.func.isRequired,
};

export default SubmitPage;
